module.exports = __webpack_public_path__ + "img/a08.3e1b0737.png";